import { styled, Heading as BaseHeading } from 'reakit'

const Heading = styled(BaseHeading)`
  color: ##272E39;
  font-size: 24px;
  letter-spacing: -0.01em;
`

export default Heading
